const TimelineContainer = ({ Resume }) => {
    const { Icon, Title, Datas } = Resume;

    return (
        <div className="mt-10">
            {/* ── Section header ── */}
            <div className="flex items-center gap-3 mb-6">
                <div
                    className="flex items-center justify-center rounded-lg flex-shrink-0"
                    style={{
                        width: "36px",
                        height: "36px",
                        background: "rgba(200,151,42,0.1)",
                        border: "1px solid rgba(200,151,42,0.25)",
                        color: "#C8972A",
                    }}
                >
                    {Icon}
                </div>
                <p
                    className="font-bold text-white"
                    style={{ fontSize: "18px", letterSpacing: "-0.01em" }}
                >
                    {Title}
                </p>
            </div>

            {/* ── Timeline entries ── */}
            <div className="relative pl-6">
                {/* Vertical gold line */}
                <div
                    className="absolute left-[7px] top-0 bottom-0"
                    style={{
                        width: "1px",
                        background:
                            "linear-gradient(to bottom, rgba(200,151,42,0.5), rgba(200,151,42,0.08))",
                    }}
                />

                {Datas.map((data, index) => (
                    <div key={data.key} className="relative mb-5">
                        {/* Timeline dot */}
                        <div
                            className="absolute"
                            style={{
                                left: "-22px",
                                top: "16px",
                                width: "9px",
                                height: "9px",
                                borderRadius: "50%",
                                background: index === 0 ? "#C8972A" : "rgba(200,151,42,0.35)",
                                border: index === 0
                                    ? "2px solid rgba(200,151,42,0.4)"
                                    : "1px solid rgba(200,151,42,0.2)",
                                boxShadow: index === 0 ? "0 0 8px rgba(200,151,42,0.4)" : "none",
                            }}
                        />

                        {/* Content card */}
                        <div
                            className="p-4 rounded-xl transition-all duration-200"
                            style={{
                                background: "rgba(255,255,255,0.03)",
                                border: "1px solid rgba(255,255,255,0.07)",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = "rgba(200,151,42,0.04)";
                                e.currentTarget.style.borderColor = "rgba(200,151,42,0.15)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = "rgba(255,255,255,0.03)";
                                e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)";
                            }}
                        >
                            {/* Role + year row */}
                            <div className="flex flex-wrap items-start justify-between gap-2 mb-1">
                                <p
                                    className="font-semibold text-white"
                                    style={{ fontSize: "14px", letterSpacing: "-0.01em" }}
                                >
                                    {data.SubTitle}
                                </p>
                                <span
                                    className="flex-shrink-0"
                                    style={{
                                        fontSize: "11px",
                                        color: "rgba(200,151,42,0.75)",
                                        fontWeight: 500,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {data.Year}
                                </span>
                            </div>

                            {/* Company */}
                            {data.Company && (
                                <p
                                    className="mb-2"
                                    style={{
                                        fontSize: "11px",
                                        color: "rgba(255,255,255,0.4)",
                                        letterSpacing: "0.02em",
                                    }}
                                >
                                    {data.Company}
                                </p>
                            )}

                            {/* Description */}
                            <p
                                className="text-gray-400 leading-relaxed"
                                style={{ fontSize: "13px" }}
                            >
                                {data.Description}
                            </p>

                            {/* Impact metrics badges */}
                            {data.Metrics && data.Metrics.length > 0 && (
                                <div className="flex flex-wrap gap-1.5 mt-3">
                                    {data.Metrics.map((metric) => (
                                        <span
                                            key={metric}
                                            style={{
                                                display: "inline-block",
                                                padding: "3px 9px",
                                                borderRadius: "4px",
                                                fontSize: "10px",
                                                fontWeight: 500,
                                                letterSpacing: "0.03em",
                                                background: "rgba(200,151,42,0.08)",
                                                border: "1px solid rgba(200,151,42,0.2)",
                                                color: "rgba(200,151,42,0.85)",
                                            }}
                                        >
                                            {metric}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TimelineContainer;
